export const DrhUrlParams = {
	Sort: {
		paramName: "s",
	},
	Facet: {
		paramName: "f",
	},
	Latitude: {
		paramName: "mlat",
	},
	Longitude: {
		paramName: "mlng",
	},
	Zoom: {
		paramName: "mzml",
	},
	Radius: {
		paramName: "mrad",
	},
};
